const lazyInlineHtml = () => {
  const schedule = (fn) => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(fn, { timeout: 1200 });
      return;
    }
    setTimeout(fn, 1200);
  };

  const parseContent = (id) => {
    const holder = document.getElementById(id);
    if (!holder) return "";
    try {
      return JSON.parse(holder.textContent);
    } catch {
      return "";
    }
  };

  const executeScripts = (root) => {
    const scripts = root.querySelectorAll("script");
    scripts.forEach((source) => {
      const replacement = document.createElement("script");
      Array.from(source.attributes).forEach((attr) => {
        replacement.setAttribute(attr.name, attr.value);
      });
      replacement.text = source.text;
      source.replaceWith(replacement);
    });
  };

  const inject = (container) => {
    if (container.dataset.loaded) return;
    const sourceId = container.getAttribute("data-lazy-html");
    if (!sourceId) return;
    const html = parseContent(sourceId);
    if (!html) return;
    container.innerHTML = html;
    executeScripts(container);
    container.dataset.loaded = "true";
  };

  const intersectionAvailable = "IntersectionObserver" in window;
  const observer = intersectionAvailable
    ? new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          const { loadMobile } = entry.target.dataset;
          if (loadMobile === "interaction" && window.matchMedia("(max-width: 767px)").matches) return;
          inject(entry.target);
        });
      }, { rootMargin: "160px" })
    : null;

  const containers = document.querySelectorAll("[data-lazy-html]");
  containers.forEach((container) => {
    if (observer) {
      observer.observe(container);
      return;
    }
    schedule(() => {
      const { loadMobile } = container.dataset;
      if (loadMobile === "interaction" && window.matchMedia("(max-width: 767px)").matches) return;
      inject(container);
    });
  });

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-lazy-trigger]");
    if (!trigger) return;
    const targetId = trigger.getAttribute("data-lazy-trigger");
    if (!targetId) return;
    const target = document.getElementById(targetId);
    if (!target) return;
    inject(target);
    trigger.removeAttribute("data-lazy-trigger");
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", lazyInlineHtml);
} else {
  lazyInlineHtml();
}
